module.exports = __webpack_public_path__ + "static/media/12.0cb63351.ogg";